import React, { useMemo, useState } from 'react';
import { FaArrowRight, FaBookOpen, FaSearch, FaTools } from 'react-icons/fa';
import wikiArticlesData from '../../Data/WikiArticles.json';
import './Wiki.css';

const WikiSearchPage = ({ onSelectArticle }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredArticles = useMemo(() => {
    const normalisedSearch = searchTerm.trim().toLowerCase();

    if (!normalisedSearch) {
      return wikiArticlesData;
    }

    return wikiArticlesData.filter((article) =>
      article.title.toLowerCase().includes(normalisedSearch) ||
      article.content.toLowerCase().includes(normalisedSearch)
    );
  }, [searchTerm]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleArticleClick = (article) => {
    onSelectArticle(article);
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    });
  };

  const handleArticleKeyDown = (event, article) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleArticleClick(article);
    }
  };

  const stripHtmlTags = (html) => {
    const temporaryElement = document.createElement("div");
    temporaryElement.innerHTML = html;
    return temporaryElement.textContent || temporaryElement.innerText || "";
  };

  return (
    <main className="technical-page">
      <div className="technical-page__frame">
        

        <section className="technical-search">
          <div className="technical-search__header">
            <FaBookOpen aria-hidden="true" />
            <div>
              <h2>Workshop Articles</h2>
              <p>
                {filteredArticles.length} of {wikiArticlesData.length} articles
              </p>
            </div>
          </div>

          <label className="technical-search__field">
            <span>Search the archive</span>
            <span className="technical-search__input-wrap">
              <FaSearch aria-hidden="true" />
              <input
                type="text"
                placeholder="Search by topic, model, or procedure"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </span>
          </label>

          <div className="technical-article-grid">
            {filteredArticles.length > 0 ? (
              filteredArticles.map((article) => (
                <button
                  key={article.id}
                  type="button"
                  className="technical-article-card"
                  onClick={() => handleArticleClick(article)}
                  onKeyDown={(event) => handleArticleKeyDown(event, article)}
                >
                  <img
                    src={require(`../../assets/wikiImages/${article.image}`)}
                    alt=""
                    aria-hidden="true"
                  />

                  <span className="technical-article-card__copy">
                    <span className="technical-article-card__title">{article.title}</span>
                    <span className="technical-article-card__preview">
                      {stripHtmlTags(article.content).substring(0, 145)}...
                    </span>
                  </span>

                  <FaArrowRight className="technical-article-card__arrow" aria-hidden="true" />
                </button>
              ))
            ) : (
              <p className="technical-search__empty">No articles found for "{searchTerm}"</p>
            )}
          </div>
        </section>
      </div>
    </main>
  );
};

export default WikiSearchPage;
